import { Edit } from '@mui/icons-material'
import { Button, Checkbox, FormControlLabel, Grid, InputAdornment, Paper, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import LeaseInformationCRU from './leaseInformationCRU';
import { globalGetService } from '../../../../utils/globalApiServices';
import { getLeaseDetailsApi } from '../apiServices';
import { checkApiStatus } from '../../../../utils';
import { PermissionWrapper } from '../../../../wrappers';
import { gaTelesisInstance, PageLoader } from '../../../../shared_elements';
import { Restore as RestoreIcon, Visibility as VisibilityIcon } from '@mui/icons-material';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import { trackActivity } from '../../../../utils/mixpanel';
import CapeTownConvention from './capeTownConvention';
import moment from 'moment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { fieldDateFormat } from '../../../../constants';
import LgGrouping from './lgGrouping';
import { useSelector } from 'react-redux';
import InfoIcon from '@mui/icons-material/Info';

const LeaseInformation = () => {
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const [editLeaseInfo, setEditLeaseInfo] = useState({ mode: "", modal: false, data: null });
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    const [leaseInfo, setLeaseInfo] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const leaseDurationTypeValue = typeof leaseInfo?.lease_duration_type === 'object' ? leaseInfo?.lease_duration_type?.value : leaseInfo?.lease_duration_type || 0;
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [isEditConvention, setEditConvention] = useState(false);

    useEffect(() => {
        getLeaseInformation();
    }, []);
    const getLeaseInformation = () => {
        setLoading(true);
        globalGetService(getLeaseDetailsApi(params?.leaseSlug))
            .then(response => {
                if (checkApiStatus(response)) {
                    setLeaseInfo(response?.data?.data || null);
                    setLoading(false);
                }
            });
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Headlines`, page_type: page_type, })
    }
    const getDurationInMonthsDays = (startDate, endDate) => {
            if (!startDate || !endDate) return "";
    
            const start = moment(startDate);
            const end = moment(endDate);
    
            if (!start.isValid() || !end.isValid()) return "";
    
            const months = end.diff(start, "months");
            const days = end.diff(start.clone().add(months, "months"), "days");
    
            const monthText = months
                ? `${months} Month${months !== 1 ? "s" : ""}`
                : "";
    
            const dayText = days
                ? `${days} Day${days !== 1 ? "s" : ""}`
                : "";
    
            return [monthText, dayText].filter(Boolean).join(" ");
        };
    return (
        <>
            <Paper className='card-container headline-readonly-fields' sx={{ p: 1, margin: '16px 1px 8px 1px', backgroundColor: '#FAFAFA', boxShadow: "0px 0px 0px 1px #BBBBBB" }}>
                <Grid sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }} mb={2}>
                    <Typography color="primary" fontSize='18px'>Lease Information</Typography>
                    <Grid>
                        <Tooltip title="Revision History">
                            <RestoreIcon fontSize="small" className="revision-history" onClick={() => { setRevisionHistory({ modal: true, data: { slug: leaseSlug }, mode: 'view' }); handleItemClicked('Lease Information RevisionHistoryIcon') }} sx={{ cursor: 'pointer' }} color="primary" />
                        </Tooltip>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "headlines", operationType: ['R'] }}>
                            <Tooltip title="View" arrow><VisibilityIcon sx={{ cursor: 'pointer' }} fontSize='small' color='primary' onClick={() => { setEditLeaseInfo({ modal: true, mode: "view", data: leaseInfo }); handleItemClicked('ViewIcon') }} /></Tooltip>
                        </PermissionWrapper>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "headlines", operationType: ['U'] }}>
                            <Tooltip title="Edit">
                                <Edit fontSize="small" color="primary" sx={{ cursor: 'pointer' }}
                                    onClick={() => { setEditLeaseInfo({ modal: true, mode: "edit", data: leaseInfo }); handleItemClicked('Lease Information EditIcon') }} />
                            </Tooltip>
                        </PermissionWrapper>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Lease Type"
                            value={leaseInfo?.lease_type?.label || ""}
                            varient="outlined" size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Lease Type ( Accounting )"
                            value={leaseInfo?.lease_type_accounting?.label || ""}
                            varient="outlined"
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                                fullWidth />
                    </Grid>
                    {/* <Grid size={{ md: 3, xs: 12 }}>
                        <Tooltip title={ leaseInfo?.default_bank?.name?.length > 23 ? leaseInfo?.default_bank?.name : "" } placement="bottom" arrow >
                            <TextField
                                label="Default Bank"
                                varient="outlined"
                                value={leaseInfo?.default_bank?.name || ""}
                                size="small"
                                margin="normal"
                                disabled={true}
                                slotProps={{ inputLabel: { shrink: true } }}
                                fullWidth />
                        </Tooltip> 
                    </Grid>*/}
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Assigned Code"
                            varient="outlined"
                            value={leaseInfo?.assigned_code || ""}
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Lease/Contract Number"
                            varient="outlined"
                            value={leaseInfo?.lease_number || ""}
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Rental Account Number"
                            value={leaseInfo?.rental_account_number || ""}
                            varient="outlined"
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Lease Duration Type"
                            varient="outlined"
                            value={leaseInfo?.lease_duration_type?.label || ""}
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>
                    {leaseDurationTypeValue===1 && leaseInfo?.rolling_lease_status && (
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label={`Rolling Lease (${leaseInfo?.rolling_lease_status===true?'Enabled':'Disabled'})`}
                            varient="outlined"
                            value={`${leaseInfo?.rolling_lease_duration || ""} ${leaseInfo?.rolling_lease_span === 1 ? 'Days' : 'Month'}`}
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>)}
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                           label={gaTelesisInstance ? "Lease Signature Date" : "Lease Contractual Start Date"}
                            value={leaseInfo?.contractual_start_date ? moment(leaseInfo?.contractual_start_date).format("DD-MM-YYYY") : null}
                            varient="outlined"
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Lease Start Date"
                            value={leaseInfo?.start_date ? moment(leaseInfo?.start_date).format("DD-MM-YYYY") : null}
                            varient="outlined"
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>
                    {![3, 5].includes(leaseDurationTypeValue) && 
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Lease End Date"
                            value={leaseInfo?.end_date ? moment(leaseInfo?.end_date).format("DD-MM-YYYY") : null}
                            varient="outlined"
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>}
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="MR Account Number"
                            value={leaseInfo?.mr_account_number || ""}
                            varient="outlined"
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Lease Term"
                            value={getDurationInMonthsDays(leaseInfo?.start_date, leaseInfo?.end_date) || ""}
                            varient="outlined"
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <TextField
                            id='governing_law'
                            label="Governing Law"
                            value={leaseInfo?.governing_law || ""}
                            variant='outlined'
                            size='small'
                            margin='normal'
                            fullWidth
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100} }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <TextField
                            id='planned_utilization'
                            label="Planned Utilization(FH)"
                            value={leaseInfo?.planned_utilization_fh || ""}
                            variant='outlined'
                            size='small'
                            margin='normal'
                            fullWidth
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <TextField
                            id='planned_utilization'
                            label="Planned Utilization(FC)"
                            value={leaseInfo?.planned_utilization_fc || ""}
                            variant='outlined'
                            size='small'
                            margin='normal'
                            fullWidth
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Lease Novation Date"
                                value={ leaseInfo?.novation_date ? moment(leaseInfo?.novation_date) : null }
                                slotProps={{
                                    textField: {
                                        InputLabelProps: { shrink: true },
                                        size: "small",
                                        margin: "normal",
                                    }
                                }}
                                sx={{ width: "100%" }}
                                format={fieldDateFormat}
                                disabled={true}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <TextField
                            id='headleases'
                            label="Headleases"
                            value={leaseInfo?.head_leases || ""}
                            variant='outlined'
                            size='small'
                            margin='normal'
                            fullWidth
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100} }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <TextField
                            id='choice_of_forum'
                            label="Choice Of Forum"
                            value={leaseInfo?.choice_of_forum || ""}
                            variant='outlined'
                            size='small'
                            margin='normal'
                            fullWidth
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <TextField
                            id='jurisdiction'
                            label="Jurisdiction"
                            value={leaseInfo?.jurisdiction || ""}
                            variant='outlined'
                            size='small'
                            margin='normal'
                            fullWidth
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                    {![1].includes(leaseDurationTypeValue) && (
                    <Grid size={{ xs: 12, md: 3 }}>
                        <TextField
                            id='time_between_overhaul'
                            label="Time between Overhaul"
                            value={leaseInfo?.time_between_overhaul || ""}
                            variant='outlined'
                            size='small'
                            margin='normal'
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            disabled="true"
                        />
                    </Grid>)}
                    {![1].includes(leaseDurationTypeValue) && (
                    <Grid size={{ xs: 12, md: 3 }}>
                        <TextField
                            id='last_overhaul_tsn'
                            label="Last Overhaul TSN"
                            value={leaseInfo?.last_overhaul_tsn || ""}
                            variant='outlined'
                            size='small'
                            margin='normal'
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            disabled={true}
                        />
                    </Grid>)}
                    {![1].includes(leaseDurationTypeValue) && (
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                label="Lease Duration"
                                value={leaseInfo?.lease_duration || ""}
                                varient="outlined"
                                size="small"
                                margin="normal"
                                disabled={true}
                                slotProps={{
                                    inputLabel: { shrink: true },
                                    input: {
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {[2, 3].includes(leaseDurationTypeValue) ? "FH" : "FC"}
                                            </InputAdornment>
                                        ),
                                    }
                                }}
                                fullWidth />
                        </Grid>)}
                    {/* <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Lease Definition of Lease Period"
                            value={leaseInfo?.definition_of_lease_period}
                            varient="outlined"
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Insurance Type"
                            value={leaseInfo?.insurance_type}
                            varient="outlined"
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid> */}
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Conditions Precedent"
                            value={leaseInfo?.conditions_precedent || ""}
                            varient="outlined"
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Alternate Dispute Redressal"
                            varient="outlined"
                            value={leaseInfo?.alternate_dispute_redressal || ""}
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid>
                    {leaseInfo?.actual_lease_end_date && leaseBasicDetails?.status==='Terminated' &&    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label="Actual Lease End Date"
                            value={leaseInfo?.actual_lease_end_date ? moment(leaseInfo?.actual_lease_end_date).format("DD-MM-YYYY") : null}
                            varient="outlined"
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid> }
                    <Grid size={{ md: 3, xs: 12 }}>
                        <TextField
                            label={
                                <span>
                                    Insurance Type
                                    <Tooltip placement='right' title={<span>Contingent or Possessed</span>} arrow>
                                        <InfoIcon fontSize='small' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'medium' }} />
                                    </Tooltip>
                                </span>
                            }
                            value={leaseInfo?.insurance_type}
                            varient="outlined"
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth />
                    </Grid> 
                    {/* <Grid size={{ md: 12, xs: 12 }}>
                        <TextField
                            label="Remarks"
                            varient="outlined"
                            value={leaseInfo?.remarks}
                            size="small"
                            margin="normal"
                            disabled={true}
                            slotProps={{ inputLabel: { shrink: true } }}
                            fullWidth
                            multiline
                            rows={3} />
                    </Grid> */}
                    <Grid size={{ md: 12, xs: 12 }}>
                        <FormControlLabel disabled id='Reserve Rate Not Applicable' label="Reserve Rate Not Applicable" control={<Checkbox checked={leaseInfo?.is_reserve_rate === 1} />} ></FormControlLabel>
                    </Grid>
                </Grid>
                {leaseBasicDetails?.asset?.asset_type === 1 &&   <Grid size={{ md: 12, xs: 12 }}>
                    <LgGrouping />
                </Grid>}
              
            
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "cape_town_convention", operationType: ['R'] }}>
                    <CapeTownConvention />
                </PermissionWrapper>

            </Paper>
            {
                editLeaseInfo?.modal ? <LeaseInformationCRU
                    editLeaseInfo={editLeaseInfo}
                    params={params?.leaseSlug}
                    modeType={editLeaseInfo.mode}
                    getResponseBack={getLeaseInformation}
                    onToggleModal={() => setEditLeaseInfo({ ...editLeaseInfo, modal: false, data: null })} /> : null
            }
            {revisionHistory?.modal ?
                <RevisionHistory
                    moduleName={"lease"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                    section_type='lease_details'
                /> : null
            }
            {isLoading ? <PageLoader /> : null}
        </>
    )
}

export default LeaseInformation;